export default function * failure ({ error }) {
  // yield alert('Register Error', 'Please try again later.')
  // console.log(JSON.stringify(error))

  // yield navigate(ROUTES.Dashboard)
}
